<ts-dialog [title]="title" (closeDialog)="dialogRef.close(false)">
  <p ts-dialog-body>
    @if (renderHtml) {
      <div [innerHTML]="description"></div>
    } @else {
      {{ description }}
    }
  </p>
  <div class="ts-dialog-actions-container" ts-dialog-actions>
    <ts-button variant="secondary" (click)="dialogRef.close(false)">{{ noLabel }}</ts-button>
    <ts-button [variant]="yesStylingVariant" (click)="dialogRef.close(true)">{{ yesLabel }}</ts-button>
  </div>
</ts-dialog>
